import { useQuery } from "@tanstack/react-query";
import {
  UniqueFieldValuesDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_PAYGAP } from "../domain";

import { paygapApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_UNIQUE_FIELD_VALUES = "GET_UNIQUE_FIELD_VALUES";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const getUniqueFieldValues = async (): Promise<UniqueFieldValuesDto> => {
  const response = await paygapApi.paygapControllerGetUniqueFieldValues();

  return response.data;
};

export const useGetUniqueFieldValues = (
  user: UserProfileDto | null,
  enabledOverride?: boolean,
): {
  uniqueFieldValues: UniqueFieldValuesDto | undefined;
  getUniqueFieldValuesEnabled: boolean;
  getUniqueFieldValuesError: Error | null;
  refetchUniqueFieldValues: () => void;
  isLoadingUniqueFieldValues: boolean;
  isFetchingUniqueFieldValues: boolean;
  isSuccessUniqueFieldValues: boolean;
} => {
  const roleEnabled = roleGuard(user, allowedRoles);
  const enabled = enabledOverride !== undefined ? enabledOverride : roleEnabled;

  const queryResult = useQuery<UniqueFieldValuesDto, Error>({
    queryKey: [DOMAIN_PAYGAP, ACTION_GET_UNIQUE_FIELD_VALUES],
    queryFn: getUniqueFieldValues,
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return {
    uniqueFieldValues: queryResult.data,
    getUniqueFieldValuesEnabled: enabled,
    getUniqueFieldValuesError: queryResult.error,
    refetchUniqueFieldValues: queryResult.refetch,
    isLoadingUniqueFieldValues: queryResult.isLoading,
    isFetchingUniqueFieldValues: queryResult.isFetching,
    isSuccessUniqueFieldValues: queryResult.isSuccess,
  };
};
